import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Grid } from "@shared/components/pagination/codebase/suite";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ServiciosService } from "../servicios.service";
import { Mensaje } from "../../../shared/components/mensajes/mensaje.modelo";
import { catchError, concatMap, takeUntil, toArray } from "rxjs/operators";
import { from, of, Subject } from "rxjs";
import { ServicioUtilidadesService } from "@shared/services/servicio-utilidades.service";

@Component({
  selector: "app-popup-configurarcapa",
  templateUrl: "./popup-configurarcapa.component.html",
  styleUrls: ["./popup-configurarcapa.component.scss"],
})
export class PopupConfigurarcapaComponent implements OnInit {
  gridConfigcapa: Grid;
  modalRef: any;
  mensaje: Mensaje;
  row: any;
  idVisorPublico: string = "MAP_LEAFLET_VISOR_PUBLICO"
  private unsubscribe$: Subject<void> = new Subject<void>();
  sistema: string;
  array: any = [];
  capasEditadas: any = [];
  configInicial: any = [];

  @ViewChild("configurarcapa", { static: true }) containerConfigurarcapa: ElementRef;

  constructor(
    private modalService: NgbModal,
    private servicios: ServiciosService,
    public utilidades: ServicioUtilidadesService
  ) {
    this.mensaje = new Mensaje("", "", "");
  }

  ngOnInit(): void {
    let clase = this;
    this.sistema = sessionStorage.getItem("sistemaLogueado");
    this.gridConfigcapa = new Grid(this.containerConfigurarcapa.nativeElement, {
      css: "dhx_demo-grid",
      columns: [
        {
          minWidth: 170,
          id: "map_nombre",
          header: [{ text: "Nombre mapa", align: "center" }, { content: "inputFilter" }],
          align: "center",
          editable: false,
          resizable: true,
        },
        {
          minWidth: 50,
          id: "cap_asociar",
          header: [{ text: "Asociar", align: "center" }, { content: "inputFilter" }],
          align: "center",
          type: "boolean",
        },
        {
          minWidth: 50,
          id: "cap_activa",
          header: [{ text: "Activa", align: "center" }, { content: "inputFilter" }],
          align: "center",
          type: "boolean",
        },
        {
          minWidth: 70,
          id: "cap_transp",
          header: [{ text: "Transparencia", align: "center" }, { content: "inputFilter" }],
          align: "center",
          type: "number"
        },
        {
          minWidth: 70,
          id: "cap_orden",
          header: [{ text: "Orden", align: "center" }, { content: "inputFilter" }],
          align: "center",
        }
      ],
      adjust: false,
      autoWidth: true,
      editable: true,
    });

    this.gridConfigcapa.events.on("afterEditEnd", function (value, row, column) {
      if ((column.id == "cap_activa" && value == true) ||
        (column.id == "cap_transp" && value != 0) ||
        (column.id == "cap_orden" && value != 0)) {
        row.cap_asociar = true;
      }

      const index = clase.capasEditadas.findIndex((_row) => _row.map_codigo === row.map_codigo);
      if (index >= 0) {
        clase.capasEditadas[index] = row;
      } else {
        clase.capasEditadas.push(row);
      }
    });

    this.obtenerMapas();
  }

  /**
   * Se realiza la petición para asociar una capa a un mapa con su configuración
   * @author Elisabeth Campuzano
   * @date 15/09/2025
   * @param
   * @returns
   */
  AsociarCapaxMapa(capa) {
    const entrada = {
      cap_codigo: capa.cap_codigo,
      map_codigo: capa.map_codigo,
      sis_codigo: this.sistema,
      cap_alias: capa.cap_alias,
      map_nombre: capa.map_nombre,
      cxm_json: {
        cap_activa: capa.cap_activa,
        cap_transp: capa.cap_transp,
        cap_orden: capa.cap_orden
      }
    };
    try {
      this.configInicial.push({
        cap_codigo: capa.cap_codigo ? capa.cap_codigo : this.row.code,
        map_codigo: capa.map_codigo,
        cap_alias: capa.cap_alias ? capa.cap_alias : this.row.alias,
        map_nombre: capa.map_nombre,
        cap_asociar: true,
        cap_activa: capa.cap_activa,
        cap_transp: capa.cap_transp,
        cap_orden: capa.cap_orden
      });
      return this.servicios.AsociarCapaxMapa(JSON.stringify(entrada));
    } catch (error) {
      this.mensaje.retornarMensaje(
        "error",
        "Atención",
        "Error al guardar la configuración de la capa",
        ""
      );
    }
  }

  /**
   * Se realiza la petición para editar la configuración de una capa
   * @author Elisabeth Campuzano
   * @date 15/09/2025
   * @param
   * @returns
   */
  EditarCapaxMapa(capa) {
    const entrada = {
      cap_codigo: capa.cap_codigo,
      map_codigo: capa.map_codigo,
      sis_codigo: this.sistema,
      cap_alias: capa.cap_alias,
      map_nombre: capa.map_nombre,
      cxm_json: {
        cap_activa: capa.cap_activa,
        cap_transp: capa.cap_transp,
        cap_orden: capa.cap_orden
      }
    };
    try {
      return this.servicios.EditarCapaxMapa(JSON.stringify(entrada));
    } catch (error) {
      this.mensaje.retornarMensaje(
        "error",
        "Atención",
        "Error al guardar la configuración de la capa",
        ""
      );
    }
  }

  /**
   * Se realiza la petición para eliminar una capa de un mapa
   * @author Elisabeth Campuzano
   * @date 15/09/2025
   * @param
   * @returns
   */
  EliminarCapaxMapa(capa) {
    const entrada = {
      cap_codigo: capa.cap_codigo,
      map_codigo: capa.map_codigo,
      sis_codigo: this.sistema,
      cap_alias: capa.cap_alias,
      map_nombre: capa.map_nombre,
      cxm_json: {
        cap_activa: capa.cap_activa,
        cap_transp: capa.cap_transp,
        cap_orden: capa.cap_orden
      }
    };
    try {
      const index = this.configInicial.findIndex((_mapa) => _mapa.map_codigo === capa.map_codigo);
      if (index >= 0) {
        this.configInicial.splice(index, 1);
      }
      return this.servicios.EliminarCapaxMapa(JSON.stringify(entrada));
    } catch (error) {
      this.mensaje.retornarMensaje(
        "error",
        "Atención",
        "Error al guardar la configuración de la capa",
        ""
      );
    }
  }

  /**
     * Carga la lista de mapas
     * @author Elisabeth Campuzano
     * @date 15/09/2025
    */
  obtenerMapas() {
    let filtro = "";
    let sistema = sessionStorage.getItem("sistemaLogueado");
    this.servicios.getServicioSigmaConsulta(sistema, "OBTENER_COMBO_MAPAS", filtro, "").subscribe(data => {
      if (data.respuesta == "true") {
        let datos = this.utilidades.RetornarStringObjeto(data.datos);
        this.array = [];
        datos.datos.forEach(mapa => {
          this.array.push({
            cap_codigo: this.row.code,
            map_codigo: mapa.map_codigo,
            cap_nombre: null,
            cap_alias: this.row.alias,
            map_nombre: mapa.map_nombre,
            cap_asociar: null,
            cap_activa: null,
            cap_transp: null,
            cap_orden: null
          });
        });
        this.gridConfigcapa.data.parse(this.array);
        this.ObtenerMapasCapa();
      }
    });
  }

  /**
   * Obtiene los mapas a los cuales está asociada la capa
   * @author Elisabeth Campuzano
   * @date 15/09/2025
   * @param
   * @returns
   */
  ObtenerMapasCapa() {
    try {
      this.servicios
        .getMapasCapa(this.row.code)
        .subscribe((respuesta) => {
          if (respuesta.state == "success") {
            respuesta.result.forEach(mapa => {
              const index = this.array.findIndex((_mapa) => _mapa.map_codigo === mapa.map_codigo);
              if (index >= 0) {
                this.array[index] = {
                  cap_codigo: mapa.cap_codigo ? mapa.cap_codigo : this.row.code,
                  map_codigo: mapa.map_codigo,
                  cap_alias: mapa.cap_alias ? mapa.cap_alias : this.row.alias,
                  map_nombre: mapa.map_nombre,
                  cap_asociar: true,
                  cap_activa: mapa.cxm_json.cap_activa,
                  cap_transp: mapa.cxm_json.cap_transp,
                  cap_orden: mapa.cxm_json.cap_orden
                }
                this.configInicial.push({
                  cap_codigo: mapa.cap_codigo ? mapa.cap_codigo : this.row.code,
                  map_codigo: mapa.map_codigo,
                  cap_alias: mapa.cap_alias ? mapa.cap_alias : this.row.alias,
                  map_nombre: mapa.map_nombre,
                  cap_asociar: true,
                  cap_activa: mapa.cxm_json.cap_activa,
                  cap_transp: mapa.cxm_json.cap_transp,
                  cap_orden: mapa.cxm_json.cap_orden
                });
              }
            });
            this.array.sort((a, b) => {
              if (a.cap_orden == null) return 1;
              if (b.cap_orden == null) return -1;
              return a.cap_orden - b.cap_orden;
            });
            this.gridConfigcapa.data.parse(this.array);
          }

        });
    } catch (error) {
      this.mensaje.retornarMensaje(
        "error",
        "Atención",
        "Error al consultar el servicio, por favor validar",
        ""
      );
    }
  }

  /**
   * Se validan los registros editados para guardar la información
   * @author Elisabeth Campuzano
   * @date 15/09/2025
   * @param
   * @returns
   */
  AccionGuardar() {
    const peticiones: any[] = [];
    this.capasEditadas.forEach((capa) => {
      if (capa.cap_asociar === true) {
        const index = this.configInicial.findIndex((_mapa) => _mapa.map_codigo === capa.map_codigo);
        if (index >= 0) {
          peticiones.push(this.EditarCapaxMapa(capa));
        }
        else {
          peticiones.push(this.AsociarCapaxMapa(capa));
        }
      }
      else if (capa.cap_asociar === false) {
        const index = this.configInicial.findIndex((_mapa) => _mapa.map_codigo === capa.map_codigo);
        if (index >= 0) {
          if (this.configInicial[index].cap_asociar == true) {
            peticiones.push(this.EliminarCapaxMapa(capa));
            capa.cap_activa = false;
            capa.cap_transp = null,
            capa.cap_orden = null
          }
        }
      }
    });

    const _request = from(peticiones).pipe(
      concatMap((req) => req.pipe(catchError((error) => of({ respuesta: 'false', error })))),
      toArray()
    );

    _request.subscribe((result) => {
      let conError = 0;
      let conExito = 0;
      result.forEach((element) => {
        if (element['state'] === 'success') {
          conExito++;
        } else {
          conError++;
        }
      });
      if (conError === 0) {
        this.mensaje.retornarMensajeFuncion(
          'confirmacionok',
          'La información fue actualizada con Éxito',
          '',
          '',
          () => {
          },
          '',
          null
        );
        this.array.sort((a, b) => {
          if (a.cap_orden == null) return 1;
          if (b.cap_orden == null) return -1;
          return a.cap_orden - b.cap_orden;
        });
        this.gridConfigcapa.data.parse(this.array);
      } else if (conExito === 0) {
        this.mensaje.retornarMensaje('error', 'Atención', 'Ocurrió un error! Por favor valide nuevamente', '');
      } else {
        this.mensaje.retornarMensajeFuncion(
          'confirmacionerror',
          'Se actualizaron ' + conExito + ' registros con exito y ' + conError + ' tuvieron error',
          '',
          '',
          () => {
          },
          '',
          null
        );
        this.modalService.dismissAll();
      }
    });
    this.capasEditadas = [];
  }

  ConfirmadoAccionGuardar(contenedor) {
    contenedor.AccionGuardar();
  }

  CancelarAccionURL(contenedor) {
    contenedor.capasEditadas = [];
    contenedor.modalService.dismissAll();
  }

  ngOnDestroy() {
    if (this.gridConfigcapa) {
      this.gridConfigcapa.destructor();
    }
  }

  CerrarModal() {
    if (this.capasEditadas.length > 0) {
      this.mensaje.retornarMensajeFuncion2(
        'confirmacion',
        'No ha almacenado los cambios realizados, ¿Desea guardarlos?',
        '',
        this,
        'ConfirmadoAccionGuardar',
        this,
        'CancelarAccionURL'
      );
    }
    else {
      this.modalService.dismissAll();
    }
  }
}
